var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.26,
    height: 19.704,
    viewBox: "0 0 24.26 19.704",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-twitter",
    "data-name": "Icon awesome-twitter",
    d: "M21.766,8.291c.015.215.015.431.015.647A14.05,14.05,0,0,1,7.635,23.084,14.051,14.051,0,0,1,0,20.852a10.286,10.286,0,0,0,1.2.062A9.958,9.958,0,0,0,7.373,18.79a4.981,4.981,0,0,1-4.649-3.448,6.27,6.27,0,0,0,.939.077,5.259,5.259,0,0,0,1.308-.169,4.973,4.973,0,0,1-3.987-4.88v-.062a5.007,5.007,0,0,0,2.247.631,4.979,4.979,0,0,1-1.539-6.65,14.133,14.133,0,0,0,10.252,5.2,5.613,5.613,0,0,1-.123-1.139,4.977,4.977,0,0,1,8.6-3.4,9.789,9.789,0,0,0,3.156-1.2A4.959,4.959,0,0,1,21.4,6.49a9.968,9.968,0,0,0,2.863-.77,10.688,10.688,0,0,1-2.494,2.571Z",
    transform: "translate(0 -3.381)",
    fill: "#606060"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterGrey);
export default __webpack_public_path__ + "static/media/twitter_grey.acb12fc0b42f243204fe186edad2c5b2.svg";
export { ForwardRef as ReactComponent };